import { useCallback } from 'react';
import { identity, pipe, prop, pick } from 'ramda';

import { get } from 'js/utils/fetch.util';
import * as helpers from 'js/components/system/Page/hocs/withCommonPage/hooks/usePageInfoFetch/helpers';
import { useIsAdmin } from 'js/hooks/user';
import { useDataFetch } from 'js/hooks/useDataFetch';
import { useClearIdsInPath } from 'js/components/system/Page/hocs/withCommonPage/hooks/useClearIdsInPath';
import { useGetCMSResourceURL } from 'js/hooks/useGetCMSResourceURL';
import { getFriendlyUrl } from 'js/utils/url.util';
import { useUserSelector, useAppSelector, useDeviceSelector } from 'js/store/hooks';

export const usePageFetch = () => {
    const [{ data: page }, refetch] = useDataFetch({
        onError: helpers.onError,
        fetch: get,
        shouldFetch: identity
    });
    const getCMSResourceURL = useGetCMSResourceURL();
    const { role, lang } = useUserSelector(pick(['role', 'lang']));
    const formFactor = useDeviceSelector(prop('formFactor'));
    const rootPage = useAppSelector(prop('rootPage'));
    const isAdmin = useIsAdmin();
    const clearIdsInPath = useClearIdsInPath();

    const fetch = useCallback((path) => {
        if (!role || !lang) {
            return;
        }

        const pageDescription = `${lang}_${formFactor}_${isAdmin ? 'ADMIN' : role.toUpperCase()}`;
        const preparePagePathURL = pipe(clearIdsInPath, getFriendlyUrl);
        const pagePathURL = preparePagePathURL(path && path !== '/' ? path : rootPage);
        const resourceURL = getCMSResourceURL(`/pageInfo/${pagePathURL}/${pageDescription}`, { t: Date.now() });

        refetch(resourceURL);
    }, [clearIdsInPath, formFactor, getCMSResourceURL, isAdmin, lang, refetch, role, rootPage]);

    return {
        page,
        fetch
    };
};
